export const SITE_TYPE = {
  ALL: 0,
  THROO: 1,
  BEHIND: 2,
  NONE: 99,
};
export const APP_TYPE = {
  WEB: 0,
  POS: 1,
  TABLEORDER: 2,
  KIOSK: 3,
  DID: 4,
  KNOCK_STORE: 10,
  KNOCK_HOTEL: 11,
};
